export enum ETripTaskStatus {
  unconfirmed = 'UNCONFIRMED',
  todo = 'TODO',
  waiting = 'WAITING',
  arrived = 'ARRIVED',
  executing = 'EXECUTING',
  done = 'DONE',
}

export const TRIP_TASK_STATUS_MAP: Record<ETripTaskStatus, string> = {
  [ETripTaskStatus.unconfirmed]: 'Draft',
  [ETripTaskStatus.todo]: 'Todo',
  [ETripTaskStatus.waiting]: 'Waiting',
  [ETripTaskStatus.arrived]: 'Arrived',
  [ETripTaskStatus.executing]: 'Active',
  [ETripTaskStatus.done]: 'Done',
};
